import { c as t } from "../../../../index.esm-BeDSGXP5.js";
import { css as o } from "styled-components";
const i = {
  imageWrapper: ({ variant: e }) => /* @__PURE__ */ o([
    "position:absolute;",
    " &::before{content:'';",
    " border-radius:50%;position:absolute;}"
  ], t({
    right: [
      "-20%",
      null
    ],
    top: [
      e === "default" ? "26%" : "11%",
      null,
      e === "default" ? "20%" : "8%",
      "5%"
    ],
    left: [
      null,
      null,
      e === "default" ? "50%" : "58%",
      "45%"
    ],
    width: [
      "60%",
      null,
      "90%",
      "90%"
    ],
    height: [
      "60%",
      null,
      "180%",
      "200%"
    ]
  }), t({
    top: [
      "5%",
      null,
      "5%",
      "5%"
    ],
    width: [
      e === "default" ? "18rem" : "19rem",
      null,
      e === "default" ? "100rem" : "28rem",
      "130rem"
    ],
    height: [
      e === "default" ? "18rem" : "19rem",
      null,
      e === "default" ? "100rem" : "28rem",
      "130rem"
    ]
  })),
  imageWrapperBackground: ({ theme: e }) => /* @__PURE__ */ o([
    "&:before{background-color:",
    ";}"
  ], e.componentColors.getApp.imageBg),
  image: ({ variant: e }) => /* @__PURE__ */ o([
    "box-sizing:border-box;position:relative;",
    ""
  ], t({
    top: [
      "0%",
      "0%",
      e === "default" ? "-3%" : "2%",
      "0%"
    ],
    left: [
      "8%",
      null,
      e === "default" ? "6%" : "5%",
      "15%"
    ],
    maxWidth: [
      "12rem",
      null,
      e === "default" ? "35rem" : "18rem",
      "40rem"
    ]
  })),
  container: ({ theme: e, bgVariant: l }) => /* @__PURE__ */ o([
    "position:relative;top:0;overflow:hidden;height:auto;background-color:",
    ";"
  ], e.componentColors.getApp[l]),
  appstoreFlex: () => /* @__PURE__ */ o([
    "@media only screen and (max-width:300px){flex-direction:column;}"
  ]),
  appstoreBox: () => /* @__PURE__ */ o([
    "@media only screen and (max-width:300px){margin-right:0;}"
  ]),
  contentBox: () => /* @__PURE__ */ o([
    "",
    ""
  ], t({
    width: [
      "60%",
      "50%",
      "50%",
      "40%"
    ]
  })),
  variableSizeBox: ({ theme: e, desktopWidth: l }) => /* @__PURE__ */ o([
    "width:",
    ";text-align:left;",
    "{width:100%;justify-content:center;text-align:center;}"
  ], l, e.breakpoints.mq.mobileMax),
  icon: ({ theme: e }) => /* @__PURE__ */ o([
    "color:",
    ";"
  ], e.componentColors.getApp.icon),
  lineHeight: () => /* @__PURE__ */ o([
    "",
    ""
  ], t({
    lineHeight: [
      "2.3rem",
      "2.3rem",
      "2.2rem",
      "2.2rem"
    ]
  }))
};
export {
  i as default
};
